import { render } from "./SelectPlusField.vue?vue&type=template&id=131c037a"
import script from "./SelectPlusField.vue?vue&type=script&lang=js"
export * from "./SelectPlusField.vue?vue&type=script&lang=js"

import "./SelectPlusField.vue?vue&type=style&index=0&id=131c037a&lang=css"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SelectPlusField.vue"]])

export default __exports__